import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps, Tag, Tooltip } from "antd";
import { useWatch } from "antd/es/form/Form";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { SaveTicketValues } from "../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { MaterialInputSelect } from "./item/MaterialInputSelect";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const MaterialInputItem = observer((props: Props) => {
  const t = useTranslation();
  const source = useWatch<string>("source");
  const sourceArray = useMemo(() => [source], [source]);
  const config = useFieldConfig<"material">("material");

  if (config && config.hidden) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.material.label");

  if (!source)
    return (
      <Tooltip title={t("maintenance:ticket.create.material.tooltip")}>
        <Tag>{t("maintenance:ticket.create.material.label")}</Tag>
      </Tooltip>
    );

  return (
    <Form.Item<SaveTicketValues>
      name="material"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.material.error.empty"),
        },
      ]}
      {...props}
    >
      {props.type === "dropdown" && (
        <MaterialInputSelect sources={sourceArray} />
      )}
    </Form.Item>
  );
});
